/*
 * Created Date: 16-01-2024, 10:38:53 am
 * Author: Victor
 * Email: victor@pt-corp.vn
 * -----
 * Last Modified:
 * Modified By:
 * -----
 * Copyright (c) 2024 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

import { useMediaQuery } from '@mui/material'

export const useBreakpoints = () => {
	const mobile = useMediaQuery('(max-width: 480px)')
	const tablet = useMediaQuery('(min-width: 768px)')
	const laptop = useMediaQuery('(min-width: 1024px)')
	const desktop = useMediaQuery('(min-width: 1536px)')

	return { mobile, tablet, laptop, desktop }
}
